import "core-js/modules/es.array.push.js";
import "core-js/modules/es.set.difference.v2.js";
import "core-js/modules/es.set.intersection.v2.js";
import "core-js/modules/es.set.is-disjoint-from.v2.js";
import "core-js/modules/es.set.is-subset-of.v2.js";
import "core-js/modules/es.set.is-superset-of.v2.js";
import "core-js/modules/es.set.symmetric-difference.v2.js";
import "core-js/modules/es.set.union.v2.js";
import "core-js/modules/esnext.iterator.map.js";
import { defineComponent as _defineComponent } from 'vue';
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment } from "vue";
import _imports_0 from '@/assets/no-data/table-empty.png';
const _hoisted_1 = {
  class: "role-dialog"
};
const _hoisted_2 = {
  class: "dialog-footer"
};
const _hoisted_3 = {
  class: "drawer-w"
};
const _hoisted_4 = {
  class: "header"
};
const _hoisted_5 = {
  class: "info-table"
};
const _hoisted_6 = {
  class: "value-cell"
};
const _hoisted_7 = ["src"];
const _hoisted_8 = {
  key: 0,
  class: "label-cell"
};
const _hoisted_9 = {
  class: "info-table"
};
const _hoisted_10 = {
  class: "value-cell"
};
const _hoisted_11 = {
  class: "info-table"
};
const _hoisted_12 = {
  key: 0,
  class: "section-title flex"
};
const _hoisted_13 = {
  key: 1,
  class: "history-cards"
};
const _hoisted_14 = {
  class: "complaint-section"
};
const _hoisted_15 = {
  class: "family-section"
};
const _hoisted_16 = {
  class: "medication-section"
};
const _hoisted_17 = {
  class: "med-name"
};
const _hoisted_18 = {
  class: "med-frequency"
};
const _hoisted_19 = {
  class: "allergy-section"
};
import { reactive, computed, ref, watch } from "vue";
import { useRoute, useRouter } from "vue-router";
import protoPagination from "@/components/proto-pagination.vue";
import { getProjectListByNameApi, getProjectDescApi } from "@/service/modules/user";
import Bus from "@/utils/bus";
import dayjs from "dayjs";
import useLoginStore from "@/store/modules/login";
import useUserStore from "@/store/modules/user";
import { safeParseJSON } from "@/utils/math";
import { getRecordLog } from "@/service/modules/record";
export default /*@__PURE__*/_defineComponent({
  __name: 'user-project-dialog',
  props: {
    dialogVisible: {
      type: Boolean,
      default: false
    },
    name: {
      type: String,
      required: true
    },
    mobile: {
      type: String,
      required: true
    }
  },
  emits: ["closeDialog", "restData"],
  setup(__props, {
    emit: __emit
  }) {
    const route = useRoute();
    const router = useRouter();
    const loginStore = useLoginStore();
    const userStore = useUserStore();
    console.log("loginStore", loginStore);
    const props = __props;
    const page = reactive({
      current: 1,
      size: 10,
      limit: 10
    });
    const emit = __emit;
    const projectList = ref([]);
    const total = ref(0);
    const drawerDialogVisible = ref(false);
    const drawerData = ref({});
    // 通过名字查档案列表
    async function getProjectByName() {
      try {
        let res = await getProjectListByNameApi({
          current: page.current,
          size: page.size,
          name: props.name,
          mobile: props.mobile
        });
        projectList.value = res.data.records;
        total.value = res.data.total;
      } catch {}
    }
    function handleToAdd(item) {
      console.log("item", item);
      router.push({
        path: "/user/add",
        query: {
          id: item.id
        }
      });
    }
    function handleprojectCurrentChange(val) {
      page.current = val;
      getProjectByName();
    }
    const highlightedFields = ref(new Set());
    // 打开抽屉
    async function handleOpenDrawerDialog(item) {
      try {
        let res = await getProjectDescApi(item.id);
        let data = res.data;
        drawerData.value = {
          ...data.record,
          allergyHistory: safeParseJSON(data.record.allergyHistory),
          familyHistory: safeParseJSON(data.record.familyHistory),
          medicationHistory: safeParseJSON(data.record.medicationHistory),
          currentMedicalHistory: safeParseJSON(data.record.currentMedicalHistory)
        };
        const logsRes = await getRecordLog(drawerData.value.id);
        if (logsRes.data && logsRes.data.length > 0) {
          highlightedFields.value = new Set(logsRes.data.map(log => log.field));
        }
        drawerDialogVisible.value = true;
        // 关闭用户项目对话框
        userStore.handleCloseUserProjectDialog();
      } catch (error) {
        console.error("Error opening drawer:", error);
      }
    }
    // 修改计算属性 highlightClass
    const highlightClass = computed(() => field => {
      return highlightedFields.value.has(field) ? "highlight" : "";
    });
    // 关闭抽屉
    function handleDrawerClose() {
      drawerDialogVisible.value = false;
      console.log("打开档案列表");
      console.log("bus", Bus);
      // Bus.emit('handleOpenUserProjectDialog')
      userStore.handleOpenUserProjectDialog();
    }
    function closeDialog() {
      emit("closeDialog");
      projectList.value = [];
    }
    function handleFooterBtn(actionType) {
      emit("closeDialog");
    }
    watch(() => props.dialogVisible, newV => {
      if (newV) {
        getProjectByName();
      }
    });
    return (_ctx, _cache) => {
      const _component_el_table_column = _resolveComponent("el-table-column");
      const _component_el_link = _resolveComponent("el-link");
      const _component_el_table = _resolveComponent("el-table");
      const _component_el_button = _resolveComponent("el-button");
      const _component_el_dialog = _resolveComponent("el-dialog");
      const _component_el_drawer = _resolveComponent("el-drawer");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_el_dialog, {
        "model-value": __props.dialogVisible,
        title: "个人档案",
        width: "35%",
        "close-on-click-modal": false,
        "close-on-press-escape": false,
        "append-to-body": true,
        "before-close": closeDialog
      }, {
        footer: _withCtx(() => [_createElementVNode("span", _hoisted_2, [_createVNode(_component_el_button, {
          onClick: _cache[0] || (_cache[0] = $event => handleFooterBtn(true)),
          type: "primary"
        }, {
          default: _withCtx(() => _cache[6] || (_cache[6] = [_createTextVNode("确定")])),
          _: 1
        })])]),
        default: _withCtx(() => [_createVNode(_component_el_table, {
          data: projectList.value,
          "header-cell-style": {
            background: '#F7F9FB !important',
            color: '#111111',
            height: '42px',
            fontSize: '14px'
          }
        }, {
          empty: _withCtx(() => _cache[5] || (_cache[5] = [_createElementVNode("div", {
            class: "table-empty"
          }, [_createElementVNode("img", {
            class: "no-data",
            src: _imports_0,
            alt: ""
          }), _createElementVNode("div", {
            class: "empty-text"
          }, "暂无数据")], -1)])),
          default: _withCtx(() => [_createVNode(_component_el_table_column, {
            prop: "name",
            label: "姓名",
            "show-overflow-tooltip": ""
          }), _createVNode(_component_el_table_column, {
            prop: "creationMonth",
            label: "建档时间",
            "show-overflow-tooltip": ""
          }), _createVNode(_component_el_table_column, {
            prop: "healthManager",
            label: "健康管理师",
            "show-overflow-tooltip": ""
          }), _createVNode(_component_el_table_column, {
            label: "操作"
          }, {
            default: _withCtx(scope => [_createVNode(_component_el_link, {
              class: "m-r-10",
              onClick: $event => handleOpenDrawerDialog(scope.row),
              type: "primary"
            }, {
              default: _withCtx(() => _cache[3] || (_cache[3] = [_createTextVNode("查看")])),
              _: 2
            }, 1032, ["onClick"]), scope.row.healthManager === _unref(loginStore).userInfo.realname || _unref(loginStore).userInfo.realname === 'admin' || _unref(loginStore).userInfo.realname === 'yilupei' ? (_openBlock(), _createBlock(_component_el_link, {
              key: 0,
              class: "m-r-10",
              onClick: $event => handleToAdd(scope.row),
              type: "warning"
            }, {
              default: _withCtx(() => _cache[4] || (_cache[4] = [_createTextVNode("编辑")])),
              _: 2
            }, 1032, ["onClick"])) : _createCommentVNode("", true)]),
            _: 1
          })]),
          _: 1
        }, 8, ["data"]), _createVNode(protoPagination, {
          page: page,
          total: total.value,
          onCurrentChange: handleprojectCurrentChange
        }, null, 8, ["page", "total"])]),
        _: 1
      }, 8, ["model-value"]), _createVNode(_component_el_drawer, {
        modelValue: drawerDialogVisible.value,
        "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => drawerDialogVisible.value = $event),
        title: "个人档案",
        size: "90%",
        "before-close": handleDrawerClose,
        direction: "rtl"
      }, {
        default: _withCtx(() => [_createElementVNode("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, [_cache[8] || (_cache[8] = _createTextVNode(" 档案信息 ")), _createVNode(_component_el_button, {
          type: "primary",
          onClick: _cache[1] || (_cache[1] = $event => handleToAdd(drawerData.value))
        }, {
          default: _withCtx(() => _cache[7] || (_cache[7] = [_createTextVNode("编辑")])),
          _: 1
        })]), _cache[50] || (_cache[50] = _createElementVNode("div", {
          class: "section-title flex"
        }, [_createElementVNode("div", {
          class: "line"
        }), _createElementVNode("div", {
          class: "label"
        }, "基本信息")], -1)), _createElementVNode("div", _hoisted_5, [_createElementVNode("table", null, [_createElementVNode("tbody", null, [_createElementVNode("tr", null, [_cache[9] || (_cache[9] = _createElementVNode("td", {
          class: "label-cell"
        }, "姓名", -1)), _createElementVNode("td", {
          class: _normalizeClass(["value-cell", highlightClass.value('name')])
        }, _toDisplayString(drawerData.value.name), 3), _cache[10] || (_cache[10] = _createElementVNode("td", {
          class: "label-cell"
        }, "性别", -1)), _createElementVNode("td", {
          class: _normalizeClass(["value-cell", highlightClass.value('gender')])
        }, _toDisplayString(drawerData.value.gender), 3), _cache[11] || (_cache[11] = _createElementVNode("td", {
          class: "label-cell"
        }, "联系电话", -1)), _createElementVNode("td", {
          class: _normalizeClass(["value-cell", highlightClass.value('mobile')])
        }, _toDisplayString(drawerData.value.mobile), 3)]), _createElementVNode("tr", null, [_cache[12] || (_cache[12] = _createElementVNode("td", {
          class: "label-cell"
        }, "年龄", -1)), _createElementVNode("td", {
          class: _normalizeClass(["value-cell", highlightClass.value('age')])
        }, _toDisplayString(drawerData.value.age), 3), _cache[13] || (_cache[13] = _createElementVNode("td", {
          class: "label-cell"
        }, "民族", -1)), _createElementVNode("td", {
          class: _normalizeClass(["value-cell", highlightClass.value('ethnicity')])
        }, _toDisplayString(drawerData.value.ethnicity), 3), _cache[14] || (_cache[14] = _createElementVNode("td", {
          class: "label-cell"
        }, "职业", -1)), _createElementVNode("td", {
          class: _normalizeClass(["value-cell", highlightClass.value('occupation')])
        }, _toDisplayString(drawerData.value.occupation), 3)]), _createElementVNode("tr", null, [_cache[15] || (_cache[15] = _createElementVNode("td", {
          class: "label-cell"
        }, "婚姻状况", -1)), _createElementVNode("td", {
          class: _normalizeClass(["value-cell", highlightClass.value('maritalStatus')])
        }, _toDisplayString(drawerData.value.maritalStatus), 3), _cache[16] || (_cache[16] = _createElementVNode("td", {
          class: "label-cell"
        }, "建档时间", -1)), _createElementVNode("td", {
          class: _normalizeClass(["value-cell", highlightClass.value('creationMonth')])
        }, _toDisplayString(drawerData.value.creationMonth), 3), _cache[17] || (_cache[17] = _createElementVNode("td", {
          class: "label-cell"
        }, "健康管理师", -1)), _createElementVNode("td", {
          class: _normalizeClass(["value-cell", highlightClass.value('healthManager')])
        }, _toDisplayString(drawerData.value.healthManager), 3)]), _createElementVNode("tr", null, [_cache[18] || (_cache[18] = _createElementVNode("td", {
          class: "label-cell"
        }, "血型", -1)), _createElementVNode("td", {
          class: _normalizeClass(["value-cell", highlightClass.value('bloodType')])
        }, _toDisplayString(drawerData.value.bloodType), 3), _cache[19] || (_cache[19] = _createElementVNode("td", {
          class: "label-cell"
        }, "出生日期", -1)), _createElementVNode("td", {
          class: _normalizeClass(["value-cell", highlightClass.value('birthdate')])
        }, _toDisplayString(_unref(dayjs)(drawerData.value.birthdate).format("YYYY-MM-DD")), 3), _cache[20] || (_cache[20] = _createElementVNode("td", {
          class: "label-cell"
        }, "婚姻状况", -1)), _createElementVNode("td", {
          class: _normalizeClass(["value-cell", highlightClass.value('maritalStatus')])
        }, _toDisplayString(drawerData.value.maritalStatus), 3)]), _createElementVNode("tr", null, [_cache[21] || (_cache[21] = _createElementVNode("td", {
          class: "label-cell"
        }, "档案编号", -1)), _createElementVNode("td", {
          class: _normalizeClass(["value-cell", highlightClass.value('fileNumber')])
        }, _toDisplayString(drawerData.value.fileNumber), 3), _cache[22] || (_cache[22] = _createElementVNode("td", {
          class: "label-cell"
        }, "档案归属", -1)), _createElementVNode("td", {
          class: _normalizeClass(["value-cell", highlightClass.value('familyMember')])
        }, _toDisplayString(drawerData.value.familyMember), 3), _cache[23] || (_cache[23] = _createElementVNode("td", {
          class: "label-cell"
        }, "家庭住址", -1)), _createElementVNode("td", {
          class: _normalizeClass(["value-cell", highlightClass.value('address')])
        }, _toDisplayString(drawerData.value.address), 3)]), _createElementVNode("tr", null, [_cache[24] || (_cache[24] = _createElementVNode("td", {
          class: "label-cell"
        }, "照片", -1)), _createElementVNode("td", _hoisted_6, [_createElementVNode("img", {
          src: drawerData.value.photo,
          alt: "",
          style: {
            "width": "100px"
          }
        }, null, 8, _hoisted_7)]), drawerData.value.phoneNumber ? (_openBlock(), _createElementBlock("td", _hoisted_8, " 家属联系电话 ")) : _createCommentVNode("", true), drawerData.value.phoneNumber ? (_openBlock(), _createElementBlock("td", {
          key: 1,
          class: _normalizeClass(["value-cell", highlightClass.value('phoneNumber')])
        }, _toDisplayString(drawerData.value.phoneNumber), 3)) : _createCommentVNode("", true)])])])]), _cache[51] || (_cache[51] = _createElementVNode("div", {
          class: "section-title flex"
        }, [_createElementVNode("div", {
          class: "line"
        }), _createElementVNode("div", {
          class: "label"
        }, "生命特征")], -1)), _createElementVNode("div", _hoisted_9, [_createElementVNode("table", null, [_createElementVNode("tbody", null, [_createElementVNode("tr", null, [_cache[25] || (_cache[25] = _createElementVNode("td", {
          class: "label-cell"
        }, "体温（℃）", -1)), _createElementVNode("td", {
          class: _normalizeClass(["value-cell", highlightClass.value('temperature')])
        }, _toDisplayString(drawerData.value.temperature), 3), _cache[26] || (_cache[26] = _createElementVNode("td", {
          class: "label-cell"
        }, "脉搏（次/分）", -1)), _createElementVNode("td", {
          class: _normalizeClass(["value-cell", highlightClass.value('pulse')])
        }, _toDisplayString(drawerData.value.pulse), 3), _cache[27] || (_cache[27] = _createElementVNode("td", {
          class: "label-cell"
        }, "呼吸（次/分）", -1)), _createElementVNode("td", {
          class: _normalizeClass(["value-cell", highlightClass.value('breathing')])
        }, _toDisplayString(drawerData.value.breathing), 3)]), _createElementVNode("tr", null, [_cache[28] || (_cache[28] = _createElementVNode("td", {
          class: "label-cell"
        }, "血压（mmHg）", -1)), _createElementVNode("td", {
          class: _normalizeClass(["value-cell", highlightClass.value('bloodPressure')])
        }, _toDisplayString(drawerData.value.bloodPressure), 3), _cache[29] || (_cache[29] = _createElementVNode("td", {
          class: "label-cell"
        }, "身高（cm）", -1)), _createElementVNode("td", {
          class: _normalizeClass(["value-cell", highlightClass.value('height')])
        }, _toDisplayString(drawerData.value.height), 3), _cache[30] || (_cache[30] = _createElementVNode("td", {
          class: "label-cell"
        }, "体重（kg）", -1)), _createElementVNode("td", _hoisted_10, _toDisplayString(drawerData.value.weight), 1)]), _createElementVNode("tr", null, [_cache[31] || (_cache[31] = _createElementVNode("td", {
          class: "label-cell"
        }, "血糖（mmol/L）", -1)), _createElementVNode("td", {
          class: _normalizeClass(["value-cell", highlightClass.value('bloodSugar')])
        }, _toDisplayString(drawerData.value.bloodSugar), 3), _cache[32] || (_cache[32] = _createElementVNode("td", {
          class: "label-cell"
        }, "体型", -1)), _createElementVNode("td", {
          class: _normalizeClass(["value-cell", highlightClass.value('bodyType')])
        }, _toDisplayString(drawerData.value.bodyType), 3), _cache[33] || (_cache[33] = _createElementVNode("td", {
          class: "label-cell"
        }, "营养状况", -1)), _createElementVNode("td", {
          class: _normalizeClass(["value-cell", highlightClass.value('nutritionStatus')])
        }, _toDisplayString(drawerData.value.nutritionStatus), 3)]), _createElementVNode("tr", null, [_cache[34] || (_cache[34] = _createElementVNode("td", {
          class: "label-cell"
        }, "体育锻炼", -1)), _createElementVNode("td", {
          class: _normalizeClass(["value-cell", highlightClass.value('exerciseHabits')])
        }, _toDisplayString(drawerData.value.exerciseHabits), 3), _cache[35] || (_cache[35] = _createElementVNode("td", {
          class: "label-cell"
        }, "饮食习惯", -1)), _createElementVNode("td", {
          class: _normalizeClass(["value-cell", highlightClass.value('dietaryHabits')])
        }, _toDisplayString(drawerData.value.dietaryHabits), 3), _cache[36] || (_cache[36] = _createElementVNode("td", {
          class: "label-cell"
        }, "睡眠情况", -1)), _createElementVNode("td", {
          class: _normalizeClass(["value-cell", highlightClass.value('sleepStatus')])
        }, _toDisplayString(drawerData.value.sleepStatus), 3)]), _createElementVNode("tr", null, [_cache[37] || (_cache[37] = _createElementVNode("td", {
          class: "label-cell"
        }, "吸烟情况", -1)), _createElementVNode("td", {
          class: _normalizeClass(["value-cell", highlightClass.value('smokingStatus')])
        }, _toDisplayString(drawerData.value.smokingStatus), 3), _cache[38] || (_cache[38] = _createElementVNode("td", {
          class: "label-cell"
        }, "饮酒情况", -1)), _createElementVNode("td", {
          class: _normalizeClass(["value-cell", highlightClass.value('alcoholConsumption')])
        }, _toDisplayString(drawerData.value.alcoholConsumption), 3), _cache[39] || (_cache[39] = _createElementVNode("td", {
          class: "label-cell"
        }, "排泄情况", -1)), _createElementVNode("td", {
          class: _normalizeClass(["value-cell", highlightClass.value('excretionStatus')])
        }, _toDisplayString(drawerData.value.excretionStatus), 3)])])])]), _cache[52] || (_cache[52] = _createElementVNode("div", {
          class: "section-title flex"
        }, [_createElementVNode("div", {
          class: "line"
        }), _createElementVNode("div", {
          class: "label"
        }, "其他")], -1)), _createElementVNode("div", _hoisted_11, [_createElementVNode("table", null, [_createElementVNode("tbody", null, [_createElementVNode("tr", null, [_cache[40] || (_cache[40] = _createElementVNode("td", {
          class: "label-cell"
        }, "自我评估", -1)), _createElementVNode("td", {
          class: _normalizeClass(["value-cell", highlightClass.value('selfEvaluation')])
        }, _toDisplayString(drawerData.value.selfEvaluation), 3), _cache[41] || (_cache[41] = _createElementVNode("td", {
          class: "label-cell"
        }, "现存的主要健康问题及隐患", -1)), _createElementVNode("td", {
          class: _normalizeClass(["value-cell", highlightClass.value('mainHealthIssues')])
        }, _toDisplayString(drawerData.value.mainHealthIssues), 3), _cache[42] || (_cache[42] = _createElementVNode("td", {
          class: "label-cell",
          style: {
            "opacity": "0"
          }
        }, null, -1)), _cache[43] || (_cache[43] = _createElementVNode("td", {
          class: "value-cell",
          style: {
            "opacity": "0"
          }
        }, null, -1))])])])]), drawerData.value.pastMedicalHistory && drawerData.value.pastMedicalHistory.length ? (_openBlock(), _createElementBlock("div", _hoisted_12, _cache[44] || (_cache[44] = [_createElementVNode("div", {
          class: "line"
        }, null, -1), _createElementVNode("div", {
          class: "label"
        }, "既往病史", -1)]))) : _createCommentVNode("", true), drawerData.value.pastMedicalHistory && drawerData.value.pastMedicalHistory.length ? (_openBlock(), _createElementBlock("div", _hoisted_13, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(drawerData.value.pastMedicalHistory, (item, index) => {
          return _openBlock(), _createElementBlock("div", {
            class: "history-card",
            key: index
          }, [_createElementVNode("div", {
            class: _normalizeClass(["card-title", highlightClass.value(`pastMedicalHistory[${index}].name`)])
          }, _toDisplayString(item.name), 3), _createElementVNode("table", null, [_createElementVNode("tbody", null, [_createElementVNode("tr", null, [_cache[45] || (_cache[45] = _createElementVNode("td", {
            class: "card-label"
          }, "诊断时间", -1)), _createElementVNode("td", {
            class: _normalizeClass(["card-value", highlightClass.value(`pastMedicalHistory[${index}].diagnosisTime`)])
          }, _toDisplayString(_unref(dayjs)(item.diagnosisTime).format("YYYY-MM-DD")), 3)]), _createElementVNode("tr", null, [_cache[46] || (_cache[46] = _createElementVNode("td", {
            class: "card-label"
          }, "确诊医院", -1)), _createElementVNode("td", {
            class: _normalizeClass(["card-value", highlightClass.value(`pastMedicalHistory[${index}].hospital`)])
          }, _toDisplayString(item.hospital), 3)]), _createElementVNode("tr", null, [_cache[47] || (_cache[47] = _createElementVNode("td", {
            class: "card-label"
          }, "诊断结果", -1)), _createElementVNode("td", {
            class: _normalizeClass(["card-value", highlightClass.value(`pastMedicalHistory[${index}].treatmentResult`)])
          }, _toDisplayString(item.treatmentResult), 3)]), _createElementVNode("tr", null, [_cache[48] || (_cache[48] = _createElementVNode("td", {
            class: "card-label"
          }, "备注", -1)), _createElementVNode("td", {
            class: _normalizeClass(["card-value", highlightClass.value(`pastMedicalHistory[${index}].remarks`)])
          }, _toDisplayString(item.remarks), 3)])])])]);
        }), 128))])) : _createCommentVNode("", true), _cache[53] || (_cache[53] = _createElementVNode("div", {
          class: "section-title flex"
        }, [_createElementVNode("div", {
          class: "line"
        }), _createElementVNode("div", {
          class: "label"
        }, "主诉")], -1)), _createElementVNode("div", _hoisted_14, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(drawerData.value.currentMedicalHistory, (item, index) => {
          return _openBlock(), _createElementBlock("div", {
            class: _normalizeClass(["complaint-item", highlightClass.value('currentMedicalHistory')]),
            key: index
          }, _toDisplayString(item), 3);
        }), 128))]), _cache[54] || (_cache[54] = _createElementVNode("div", {
          class: "section-title flex"
        }, [_createElementVNode("div", {
          class: "line"
        }), _createElementVNode("div", {
          class: "label"
        }, "家族史")], -1)), _createElementVNode("div", _hoisted_15, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(drawerData.value.familyHistory, (item, index) => {
          return _openBlock(), _createElementBlock("div", {
            class: "family-item",
            key: index
          }, _toDisplayString(item), 1);
        }), 128))]), _cache[55] || (_cache[55] = _createElementVNode("div", {
          class: "section-title flex"
        }, [_createElementVNode("div", {
          class: "line"
        }), _createElementVNode("div", {
          class: "label"
        }, "用药情况")], -1)), _createElementVNode("div", _hoisted_16, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(drawerData.value.medicationHistory, (item, index) => {
          return _openBlock(), _createElementBlock("div", {
            class: _normalizeClass(["medication-item", highlightClass.value('medicationHistory')]),
            key: index
          }, [_createElementVNode("div", _hoisted_17, _toDisplayString(item?.name), 1), _cache[49] || (_cache[49] = _createElementVNode("div", {
            class: "med-usage"
          }, "用法用量", -1)), _createElementVNode("div", _hoisted_18, _toDisplayString(item?.value), 1)], 2);
        }), 128))]), _cache[56] || (_cache[56] = _createElementVNode("div", {
          class: "section-title flex"
        }, [_createElementVNode("div", {
          class: "line"
        }), _createElementVNode("div", {
          class: "label"
        }, "过敏史")], -1)), _createElementVNode("div", _hoisted_19, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(drawerData.value.allergyHistory, (item, index) => {
          return _openBlock(), _createElementBlock("div", {
            class: _normalizeClass(["allergy-item", highlightClass.value('allergyHistory')]),
            key: index
          }, _toDisplayString(item), 3);
        }), 128))])])]),
        _: 1
      }, 8, ["modelValue"])]);
    };
  }
});